import React$1 from 'react';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Icon$1 from '../Icon/Icon.js';
import Spinner$1 from '../Spinner/Spinner.js';
import StyledButton from './Button.style.js';

const Button = (_ref) => {
  let {
    children,
    icon,
    variant,
    iconAlignment,
    noHover,
    loading,
    disabled
  } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "icon", "variant", "iconAlignment", "noHover", "loading", "disabled"]);

  return /*#__PURE__*/React$1.createElement(StyledButton, _extends({
    icon: icon,
    variant: variant,
    disabled: loading || disabled
  }, props), loading && /*#__PURE__*/React$1.createElement(Spinner$1, {
    size: "small"
  }), !loading && /*#__PURE__*/React$1.createElement("span", {
    className: "button__label"
  }, icon && iconAlignment === 'before' && /*#__PURE__*/React$1.createElement(Icon$1, {
    icon: icon,
    alignment: "left"
  }), children, icon && iconAlignment === 'after' && /*#__PURE__*/React$1.createElement(Icon$1, {
    icon: icon,
    alignment: "right"
  })));
};

Button.propTypes = {
  loading: PropTypes$1.bool,
  disabled: PropTypes$1.bool,
  children: PropTypes$1.node.isRequired,
  icon: PropTypes$1.string,
  variant: PropTypes$1.oneOf(['primary', 'secondary']),
  iconAlignment: PropTypes$1.oneOf(['before', 'after']),
  noHover: PropTypes$1.bool
};
Button.defaultProps = {
  icon: null,
  variant: 'primary',
  iconAlignment: 'after',
  noHover: false,
  loading: false,
  disabled: false
};

export default Button;
